import { createSpinnerTabler } from '@subaio/components'

export const Spinner = createSpinnerTabler((props: { theme: any }) => ({
	color: props.theme.color.input.loadingIndicator,
	backgroundColor: props.theme.color.input.loadingIndicatorBackground,
}))
